import { render, staticRenderFns } from "./CustomForm.vue?vue&type=template&id=5d3ea1f7&scoped=true&"
import script from "./CustomForm.vue?vue&type=script&lang=ts&"
export * from "./CustomForm.vue?vue&type=script&lang=ts&"
import style0 from "./CustomForm.vue?vue&type=style&index=0&id=5d3ea1f7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d3ea1f7",
  null
  
)

export default component.exports